module.exports = __webpack_public_path__ + "static/img/solution-y-2.f41a612.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/Main/solution-y-2.png
// module id = /Law
// module chunks = 10